/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagReference
 */
export interface TagReference {
    /**
     * 
     * @type {number}
     * @memberof TagReference
     */
    id: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TagReference
     */
    readonly roots?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TagReference
     */
    readonly name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TagReference
     */
    readonly shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TagReference
     */
    readonly color?: string;
}

export function TagReferenceFromJSON(json: any): TagReference {
    return TagReferenceFromJSONTyped(json, false);
}

export function TagReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'roots': !exists(json, 'roots') ? undefined : json['roots'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function TagReferenceToJSON(value?: TagReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


